import React from 'react';

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-image">
        <img
          src="/stock/pexels-n-voitkevich-7615470.jpg"
          alt="MindLever Premium Supplements"
        />
      </div>
      <div className="hero-content container">
        <h1 className="hero-title">Functional Mushroom Extracts</h1>
      </div>
    </section>
  );
};

export default Hero;
